module.exports = __webpack_public_path__ + "static/DEV1-ecfb4ce32f3fac85933186740fe050fd.png";